import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import ComentarioAuditoria from "model/auditoria5s/auditoria/ComentarioAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";
import { Label } from "components/input/Label";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";

type Props = {
    visible: boolean;
    onHide: () => void;
    item: ItemClasseAuditoria;
    comentario: ComentarioAuditoria | null;
    onSave: (comentario: ComentarioAuditoria) => void
}

const execucaoAuditoriaService = new ExecucaoAuditoriaService();
export default function ModalComentarioAuditoriaCadastro(props: Props) {

    const [comentario, setComentario] = useState<ComentarioAuditoria>(new ComentarioAuditoria());
    const [imagens, setImagens] = useState<any[]>([]);
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgAlerta } = useToastContext();

    useEffect(() => {

        if (props.comentario) {
            let comentarioLocal = props.comentario;
            comentarioLocal.itemAuditoria = { ...props.item, comentariosAuditoria: [] };

            setComentario(comentarioLocal);
        } else {
            comentario.itemAuditoria = { ...props.item, comentariosAuditoria: [] };
            comentario.comentario = '';
            comentario.imagens = [];
            setComentario({ ...comentario });
        }

    }, []);

    function salvarComentario() {
        startLoading()

        const data = getFormData("comentarioAuditoria", comentario, imagens, "imagens");

        execucaoAuditoriaService.salvarComentario(data).then(comentarioRetorno => {
            stopLoading()
            props.onSave(comentarioRetorno);
            props.onHide();
        }).catch(e => {
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Não foi possível salvar o comentário!');
            }
            console.log(e);
            stopLoading()
        });


    }

    return (

        <Dialog visible={props.visible} style={{ width: '100%', maxWidth: 600 }} onHide={() => props.onHide()} header="Comentário" footer={<div>
            <Button style={{ marginLeft: 8, marginRight: 8, marginTop: 8, color: "#FFF", backgroundColor: '#FF0000', borderWidth: 0 }} onClick={() => {
                props.onHide();
            }}>Cancelar</Button>
            <Button style={{ marginLeft: 8, marginRight: 8, marginTop: 8, color: "#FFF", backgroundColor: '#240E92' }} onClick={() => {
                salvarComentario();
            }}>Gravar Comentário</Button>
        </div>}>


            <div style={{ backgroundColor: 'transparent' }}>
                <div style={{ padding: 8, margin: 8 }}>
                    <Checkbox checked={comentario.destaque} onChange={(e) => { setComentario({ ...comentario, destaque: e.checked as boolean }) }} />
                    <label style={{ marginLeft: 8 }} >Destacar comentário?</label>
                </div>

                <div style={{ padding: 8, margin: 8 }}>
                    <Label style={{ paddingBottom: 4 }}>Comentário</Label>
                    <InputTextarea
                        style={{ width: '100%' }}
                        placeholder='Descrição'
                        value={comentario.comentario}
                        onChange={(e) => {
                            comentario.comentario = e.target.value;
                            setComentario({ ...comentario });
                        }} />
                </div>


                <div className="row">
                    <div className="col-sm-12">
                        <AnexoPanel
                            accept="image/*"
                            novosAnexos={imagens} onChangeNovosAnexos={(e: any) => setImagens(e)}
                            arquivos={comentario.imagens} onChange={(e) => {
                                console.log(e);
                                setComentario({ ...comentario, imagens: e })
                            }}
                            collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                        />
                    </div>
                </div>



            </div>

        </Dialog>
    );
}